import { useNavigate } from "react-router-dom";
import { FaSun, FaMoon } from 'react-icons/fa';
import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import axios from "axios";
import { Navigate } from 'react-router-dom';

import { Link, useLocation } from "react-router-dom";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  Container,
  Button,
} from "reactstrap";

import routes from "routes.js";

function Header(props) {
  const [isOpen, setIsOpen] = React.useState(false);
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const [color, setColor] = React.useState(theme === "light" ? "transparent" : "dark");
  const sidebarToggle = React.useRef();
  const location = useLocation();
  const [theme, setTheme] = React.useState("light");
  

  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    setColor(newTheme === "light" ? "transparent" : "dark");
    // Optionally, save the theme preference to localStorage or cookies
  };
  
  const navigate = useNavigate();
  const token = localStorage.getItem('token'); // Get the user's token


  
  const handleLogout = () => {
    // Remove the token and user role from local storage and cookies
    localStorage.removeItem("userData");
    localStorage.removeItem("token");
    localStorage.removeItem("userRole");
    Cookies.remove("token");
  
    // Redirect to the login page
    navigate("/");
    console.log("Logout clicked");
  };
  

  
  
  
  const toggle = () => {
    if (isOpen) {
      setColor("transparent");
    } else {
      setColor("dark");
    }
    setIsOpen(!isOpen);
  };
  const dropdownToggle = (e) => {
    setDropdownOpen(!dropdownOpen);
  };
  const getBrand = () => {
    let brandName = "Default Brand";
    routes.map((prop, key) => {
      if (window.location.href.indexOf(prop.layout + prop.path) !== -1) {
        brandName = prop.name;
      }
      return null;
    });
    return brandName;
  };
  const openSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
    sidebarToggle.current.classList.toggle("toggled");
  };
  // function that adds color dark/transparent to the navbar on resize (this is for the collapse)
  const updateColor = () => {
    if (window.innerWidth < 993 && isOpen) {
      setColor("dark");
    } else {
      setColor("transparent");
    }
  };
  React.useEffect(() => {
    window.addEventListener("resize", updateColor.bind(this));
  });
  React.useEffect(() => {
    if (
      window.innerWidth < 993 &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
      sidebarToggle.current.classList.toggle("toggled");
    }
  }, [location]);

  // Check if the user is authenticated based on the token
  const isAuthenticated = !!token;

  // Handle the case when the user is not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  
  return (
    // add or remove classes depending if we are on full-screen-maps page or not
    <Navbar
    color={
      location.pathname.indexOf("full-screen-maps") !== -1 ? "dark" : color
    }
    expand="lg"
    className={
      location.pathname.indexOf("full-screen-maps") !== -1
        ? "navbar-absolute fixed-top"
        : "navbar-absolute fixed-top " +
          (color === "transparent" ? "navbar-transparent " : "")
    }
  >
      <Container fluid>
        <div className="navbar-wrapper">
          <div className="navbar-toggle">
            <button
              type="button"
              ref={sidebarToggle}
              className="navbar-toggler"
              onClick={() => openSidebar()}
            >
              <span className="navbar-toggler-bar bar1" />
              <span className="navbar-toggler-bar bar2" />
              <span className="navbar-toggler-bar bar3" />
            </button>
          </div>
          <NavbarBrand >{getBrand()}</NavbarBrand>
        </div>
        <NavbarToggler onClick={toggle}>
          <span className="navbar-toggler-bar navbar-kebab" />
          <span className="navbar-toggler-bar navbar-kebab" />
          <span className="navbar-toggler-bar navbar-kebab" />
        </NavbarToggler>
        <Collapse isOpen={isOpen} navbar className="justify-content-end">
      <Nav navbar>
        <tr>
        {/* <td className="pr-4">
      <Button color="info" onClick={toggleTheme} className="ml-3">
            {theme === "light" ? <FaMoon /> : <FaSun />}
          </Button>
   </td>
   {' '} */}
   <td>
        <Button color="primary" onClick={handleLogout}>
          Logout
        </Button>
    </td>
    </tr>
  
      </Nav>
    </Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
